import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BBIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BB" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M11.2 0H16v12h-4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h4.8v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#000"
        fillRule="evenodd"
        d="M9.217 7.637c.317-.655.682-1.85.682-1.85l.277-.822-1.098.398.26.15s-.453.906-.681 1.348c-.228.442-.25.15-.25.15l.038-3.085.252-.068-.627-1.206-.801 1.223.353.01s-.03 3.254-.079 3.126c-.027-.073-.1.152-.136.065-.222-.545-.526-1.602-.526-1.602l.178-.167-1.195-.245.357.734s.314 1.308.66 1.947c.077.202.453.288.453.288s.183-.186.229 0c.045.186 0 .938 0 .938h.843s-.059-.709 0-.938c.06-.228.244 0 .244 0s.49-.192.567-.394Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
